export default () => ({
    PreviousStep: {
        paddingTop: 9,
        marginLeft: -4
    },
    Arrow: {
        fontSize: 22,
        verticalAlign: 'baseline'
    },
    Text: {
        verticalAlign: 'baseline'
    }
});
